import React from 'react';
import { Link } from 'react-router-dom';
import { Target } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-coral-600 rounded-full flex items-center justify-center">
                <Target className="w-6 h-6 text-white" />
              </div>
              <span className="text-lg font-bold">Morning Sunday Teer</span>
            </div>
            <p className="text-gray-400 text-sm">
              Your trusted source for Morning Sunday Teer results, Shillong Morning Teer updates, and previous results.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/previous-results" className="text-gray-400 hover:text-white transition-colors">
                  Previous Results
                </Link>
              </li>
              <li>
                <Link to="/common-numbers" className="text-gray-400 hover:text-white transition-colors">
                  Common Numbers
                </Link>
              </li>
              <li>
                <Link to="/dream-number" className="text-gray-400 hover:text-white transition-colors">
                  Dream Number
                </Link>
              </li>
              <li>
                <Link to="/house-target" className="text-gray-400 hover:text-white transition-colors">
                  House Target
                </Link>
              </li>
            </ul>
          </div>

          {/* Disclaimer */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Disclaimer</h3>
            <p className="text-gray-400 text-sm">
              This website provides information for educational purposes only. Please verify all results with official sources.
            </p>
          </div>
        </div>

        {/* SEO Keywords Section */}
        <div className="border-t border-gray-800 mt-8 pt-8">
          <h4 className="text-lg font-semibold mb-4 text-center">Popular Searches</h4>
          <div className="flex flex-wrap justify-center gap-3 mb-6">
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning Sunday Teer
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning Sunday Teer Result
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning Sunday Teer Result Today
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              Sunday morning teer
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning teer
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning teer Result
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              Shillong morning Teer
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning Shillong Teer
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/common-numbers" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning teer common number
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/dream-number" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning teer dream number
            </Link>
            <span className="text-gray-700">|</span>
            <Link to="/previous-results" className="text-gray-400 hover:text-coral-400 text-sm transition-colors">
              morning teer previous result
            </Link>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6 text-center text-gray-400 text-sm">
          <p>&copy; 2026 Morning Sunday Teer. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
